import React from "react";
import {IconChipMultiplePerson, IconNotebook, IconPersonPlusCard} from "../../../../../components/buttons/IconButtons";
import CustomAvailableItems from "../../../../../components/CustomAvailableAssignedItems/CustomAvailableItems";
import SelectedUserEmailPhoneCard from "../../../../../components/CustomAvailableAssignedItems/SubComponents/SelectedUserEmailPhoneCard";
import {SimpleSearch} from "../../../../../reduxToolkit/Search/SearchApi";
import {TABLES} from "../../../../../Apis/Tables";
import ZoneAccessItemTabs from "../ZoneAccessItemTabs";
import GuardStepApp from "../../Functionality/GuardStepApp";

/**
 * Guards of the zone access, picked from the available ones paged and searched by name, email or phone.
 * On the update, the guards are split in a tab to add new ones and a tab with the ones already assigned.
 *
 * @param {string} zoneAccessId Zone access being updated, whose guards are listed as assigned.
 * @param {boolean} isUpdate Whether the zone access is being updated.
 * @param {Array} selectedGuards Guards picked, kept by the form to validate and save them.
 * @param {Function} setSelectedGuards Setter of the picked guards.
 * @param {Array} assignedGuards Guards already assigned to the zone access being updated.
 * @param {Function} removeAssignedGuards Removes the given guard user ids from the zone access right away.
 * @param {boolean} canSave Whether the assigned guards can be removed.
 * @param {boolean} disabled Read-only, the zone access is only shown.
 */
const GuardStep = ({
                       zoneAccessId,
                       isUpdate,
                       selectedGuards,
                       setSelectedGuards,
                       assignedGuards,
                       removeAssignedGuards,
                       canSave,
                       disabled = false
                   }) => {
    const {
        guardResults,
        setGuardResults,
        guardSearchElement,
        setGuardSearchElement,
        setGuardSearch,
        setGuardSimpleSearch,
        setGuardBodyForExport,
        guardModified,
        setGuardModified,
        guardTableBuildBody,
    } = GuardStepApp(zoneAccessId);


    const availableItems = (
        <CustomAvailableItems
            id={null}
            results={guardResults}
            setResults={setGuardResults}
            searchElement={guardSearchElement}
            setSearchElement={setGuardSearchElement}
            setSearch={setGuardSearch}
            setSimpleSearch={setGuardSimpleSearch}
            setBodyForExport={setGuardBodyForExport}
            modified={guardModified}
            setModified={setGuardModified}
            selected={selectedGuards}
            setSelected={setSelectedGuards}
            keyId={'userId'}
            tableEndPoint={SimpleSearch}
            tableBuildBody={guardTableBuildBody}
            labelRowsPerPage={'guards_per_page'}
            titleContainer={'available_guards'}
            selectedSectionTitle={'selected_guards'}
            tableNotInformationLegend={'you_have_not_created_any_guards_yet'}
            selectedSectionNotInformationLegend={'nothing_selected_yet'}
            tableIconTitle={<IconNotebook className={"icon-color-general-950"}/>}
            selectedSectionIconTitle={<IconChipMultiplePerson width={24} height={24} className={"icon-color-general-950"}/>}
        />
    );

    return (
        <div>
            {isUpdate
                ?
                <ZoneAccessItemTabs
                    id={'zaf_guards'}
                    zoneAccessId={zoneAccessId}
                    addTab={{title: 'add_guards', icon: <IconPersonPlusCard width={24} height={24}/>}}
                    assignedTab={{title: 'assigned_guards', icon: <IconChipMultiplePerson width={24} height={24}/>}}
                    addContent={availableItems}
                    assigned={assignedGuards}
                    assignedList={{
                        model: TABLES.ZONE_ACCESS_ASSIGNED_GUARD,
                        keyId: 'userId',
                        labelRowsPerPage: 'guards_per_page',
                        searchTitle: 'search_by_name_email_or_phone',
                        notInformationLegend: 'nothing_selected_yet',
                        renderAssignedItem: ({item, keyId, onDelete, checkbox, handleCheckboxChange, selected}) => (
                            <SelectedUserEmailPhoneCard
                                keyId={keyId}
                                item={{...item, disabled: false, checked: selected.includes(item[keyId])}}
                                onDelete={onDelete}
                                handleCheckboxChange={checkbox ? handleCheckboxChange : undefined}
                            />
                        ),
                    }}
                    canDelete={canSave}
                    disabled={disabled}
                    onRemove={removeAssignedGuards}
                    removeTitle={'remove_guards'}
                    removeElement={'guards'}
                    results={guardResults}
                    setResults={setGuardResults}
                    searchElement={guardSearchElement}
                    setSearchElement={setGuardSearchElement}
                    setSearch={setGuardSearch}
                    setSimpleSearch={setGuardSimpleSearch}
                    setBodyForExport={setGuardBodyForExport}
                    modified={guardModified}
                    setModified={setGuardModified}
                />
                :
                availableItems
            }
        </div>
    );
};

export default GuardStep;
